(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var CoroutineImpl = kotlin_kotlin.$_$.g8;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.h;
  var isObject = kotlin_kotlin.$_$.p9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.y;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.r7;
  var classMeta = kotlin_kotlin.$_$.v8;
  var Sender = kotlin_io_ktor_ktor_client_core.$_$.m;
  var isInterface = kotlin_kotlin.$_$.n9;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.q;
  var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.n;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.f1;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.k;
  var parseAuthorizationHeader = kotlin_io_ktor_ktor_http.$_$.q;
  var first = kotlin_kotlin.$_$.e6;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.m;
  var Phases_getInstance = kotlin_io_ktor_ktor_client_core.$_$.f;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_core.$_$.e;
  var plugin = kotlin_io_ktor_ktor_client_core.$_$.p;
  var HttpClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.l;
  var objectMeta = kotlin_kotlin.$_$.y9;
  var SuspendFunction2 = kotlin_kotlin.$_$.j8;
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var CompletableDeferred$default = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e;
  var ensureNotNull = kotlin_kotlin.$_$.id;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c1;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.c;
  var headers = kotlin_io_ktor_ktor_client_core.$_$.t;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.e2;
  var AuthScheme_getInstance = kotlin_io_ktor_ktor_http.$_$.f;
  var Parameterized = kotlin_io_ktor_ktor_http.$_$.p;
  var SuspendFunction1 = kotlin_kotlin.$_$.i8;
  var SuspendFunction0 = kotlin_kotlin.$_$.h8;
  //endregion
  //region block: pre-declaration
  Auth$Plugin$install$slambda.prototype = Object.create(CoroutineImpl.prototype);
  Auth$Plugin$install$slambda.prototype.constructor = Auth$Plugin$install$slambda;
  Auth$Plugin$install$slambda_1.prototype = Object.create(CoroutineImpl.prototype);
  Auth$Plugin$install$slambda_1.prototype.constructor = Auth$Plugin$install$slambda_1;
  function sendWithoutRequest(request) {
    return this.q48();
  }
  function addRequestHeaders$default(request, authHeader, $cont, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      authHeader = null;
    return $handler == null ? this.m48(request, authHeader, $cont) : $handler(request, authHeader, $cont);
  }
  function refreshToken(response, $cont) {
    return true;
  }
  $loadTokenCOROUTINE$0.prototype = Object.create(CoroutineImpl.prototype);
  $loadTokenCOROUTINE$0.prototype.constructor = $loadTokenCOROUTINE$0;
  $setTokenCOROUTINE$1.prototype = Object.create(CoroutineImpl.prototype);
  $setTokenCOROUTINE$1.prototype.constructor = $setTokenCOROUTINE$1;
  BearerAuthConfig$_refreshTokens$slambda.prototype = Object.create(CoroutineImpl.prototype);
  BearerAuthConfig$_refreshTokens$slambda.prototype.constructor = BearerAuthConfig$_refreshTokens$slambda;
  BearerAuthConfig$_loadTokens$slambda.prototype = Object.create(CoroutineImpl.prototype);
  BearerAuthConfig$_loadTokens$slambda.prototype.constructor = BearerAuthConfig$_loadTokens$slambda;
  BearerAuthProvider$refreshToken$slambda.prototype = Object.create(CoroutineImpl.prototype);
  BearerAuthProvider$refreshToken$slambda.prototype.constructor = BearerAuthProvider$refreshToken$slambda;
  $addRequestHeadersCOROUTINE$2.prototype = Object.create(CoroutineImpl.prototype);
  $addRequestHeadersCOROUTINE$2.prototype.constructor = $addRequestHeadersCOROUTINE$2;
  $refreshTokenCOROUTINE$3.prototype = Object.create(CoroutineImpl.prototype);
  $refreshTokenCOROUTINE$3.prototype.constructor = $refreshTokenCOROUTINE$3;
  //endregion
  function Auth$Plugin$install$slambda($plugin, resultContinuation) {
    this.g47_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  Auth$Plugin$install$slambda.prototype.r37 = function ($this$intercept, it, $cont) {
    var tmp = this.s37($this$intercept, it, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  Auth$Plugin$install$slambda.prototype.g8 = function (p1, p2, $cont) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.r37(tmp, isObject(p2) ? p2 : THROW_CCE(), $cont);
  };
  Auth$Plugin$install$slambda.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 4;
            var tmp_0 = this;
            var tmp0_filter = this.g47_1.m47_1;
            var tmp0_filterTo = ArrayList_init_$Create$();
            var tmp0_iterator = tmp0_filter.d();
            while (tmp0_iterator.e()) {
              var element = tmp0_iterator.f();
              if (element.n47(this.h47_1.r1w_1)) {
                tmp0_filterTo.b(element);
              }
            }

            tmp_0.j47_1 = tmp0_filterTo;
            this.k47_1 = this.j47_1.d();
            this.kj_1 = 1;
            continue $sm;
          case 1:
            if (!this.k47_1.e()) {
              this.kj_1 = 3;
              continue $sm;
            }

            this.l47_1 = this.k47_1.f();
            this.kj_1 = 2;
            suspendResult = this.l47_1.o47(this.h47_1.r1w_1, null, this, 2, null);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.kj_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 4) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  Auth$Plugin$install$slambda.prototype.s37 = function ($this$intercept, it, completion) {
    var i = new Auth$Plugin$install$slambda(this.g47_1, completion);
    i.h47_1 = $this$intercept;
    i.i47_1 = it;
    return i;
  };
  Auth$Plugin$install$slambda.$metadata$ = classMeta('Auth$Plugin$install$slambda', undefined, undefined, undefined, [2], CoroutineImpl.prototype);
  function Auth$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new Auth$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $cont) {
      return i.r37($this$intercept, it, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function Auth$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.x47_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  Auth$Plugin$install$slambda_1.prototype.w3m = function ($this$intercept, context, $cont) {
    var tmp = this.x3m($this$intercept, context, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  Auth$Plugin$install$slambda_1.prototype.g8 = function (p1, p2, $cont) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.w3m(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $cont);
  };
  Auth$Plugin$install$slambda_1.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 8;
            this.kj_1 = 1;
            suspendResult = this.y47_1.a3a(this.z47_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a48_1 = suspendResult;
            if (!this.a48_1.y37().h2a().equals(Companion_getInstance().s25_1))
              return this.a48_1;
            if (this.a48_1.h3b().m3a().a1q(Plugin_getInstance_0().i48_1))
              return this.a48_1;
            this.b48_1 = this.a48_1;
            this.c48_1 = HashSet_init_$Create$(this.x47_1.m47_1);
            this.kj_1 = 2;
            continue $sm;
          case 2:
            if (!this.b48_1.y37().h2a().equals(Companion_getInstance().s25_1)) {
              this.kj_1 = 7;
              continue $sm;
            }

            this.d48_1 = this.b48_1.y37().f24().v1s(HttpHeaders_getInstance().a23_1);
            var tmp_0 = this;
            var tmp0_safe_receiver = this.d48_1;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = parseAuthorizationHeader(this.d48_1);
            }

            tmp_0.e48_1 = tmp_1;
            var tmp_2 = this;
            var tmp_3;
            if (this.e48_1 == null ? this.c48_1.g() === 1 : false) {
              tmp_3 = first(this.c48_1);
            } else if (this.e48_1 == null) {
              return this.b48_1;
            } else {
              var tmp$ret$0;
              l$ret$1: do {
                var tmp0_iterator = this.c48_1.d();
                while (tmp0_iterator.e()) {
                  var element = tmp0_iterator.f();
                  if (element.k48(this.e48_1)) {
                    tmp$ret$0 = element;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = null;
              }
               while (false);
              var tmp1_elvis_lhs = tmp$ret$0;
              var tmp_4;
              if (tmp1_elvis_lhs == null) {
                return this.b48_1;
              } else {
                tmp_4 = tmp1_elvis_lhs;
              }
              tmp_3 = tmp_4;
            }

            tmp_2.f48_1 = tmp_3;
            this.kj_1 = 3;
            suspendResult = this.f48_1.l48(this.b48_1.y37(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.g48_1 = suspendResult;
            if (!this.g48_1) {
              return this.b48_1;
            } else {
              this.kj_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this.c48_1.dd(this.f48_1);
            ;
            this.h48_1 = new HttpRequestBuilder();
            this.h48_1.w3e(this.z47_1);
            ;
            this.kj_1 = 5;
            suspendResult = this.f48_1.m48(this.h48_1, this.e48_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.h48_1.c39_1.b1q(Plugin_getInstance_0().i48_1, Unit_getInstance());
            this.kj_1 = 6;
            suspendResult = this.y47_1.a3a(this.h48_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.b48_1 = suspendResult;
            this.kj_1 = 2;
            continue $sm;
          case 7:
            return this.b48_1;
          case 8:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 8) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  Auth$Plugin$install$slambda_1.prototype.x3m = function ($this$intercept, context, completion) {
    var i = new Auth$Plugin$install$slambda_1(this.x47_1, completion);
    i.y47_1 = $this$intercept;
    i.z47_1 = context;
    return i;
  };
  Auth$Plugin$install$slambda_1.$metadata$ = classMeta('Auth$Plugin$install$slambda', undefined, undefined, undefined, [2], CoroutineImpl.prototype);
  function Auth$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new Auth$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, context, $cont) {
      return i.w3m($this$intercept, context, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function Auth_init_$Init$(providers, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp$ret$0 = ArrayList_init_$Create$();
      tmp$ret$0_0 = Unit_getInstance();
      providers = tmp$ret$0;
    }
    Auth.call($this, providers);
    return $this;
  }
  function Auth_init_$Create$(providers, $mask0, $marker) {
    return Auth_init_$Init$(providers, $mask0, $marker, Object.create(Auth.prototype));
  }
  function Plugin() {
    Plugin_instance = this;
    this.i48_1 = new AttributeKey('auth-request');
    this.j48_1 = new AttributeKey('DigestAuth');
  }
  Plugin.prototype.w = function () {
    return this.j48_1;
  };
  Plugin.prototype.n48 = function (block) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = Auth_init_$Create$(null, 1, null);
    // Inline function 'kotlin.contracts.contract' call
    block(tmp0_apply);
    tmp$ret$0 = tmp0_apply;
    return tmp$ret$0;
  };
  Plugin.prototype.c3a = function (block) {
    return this.n48(block);
  };
  Plugin.prototype.o48 = function (plugin_0, scope) {
    var tmp = Phases_getInstance().v3f_1;
    scope.x36_1.v1w(tmp, Auth$Plugin$install$slambda_0(plugin_0, null));
    var tmp_0 = plugin(scope, Plugin_getInstance());
    tmp_0.g3o(Auth$Plugin$install$slambda_2(plugin_0, null));
  };
  Plugin.prototype.d3a = function (plugin, scope) {
    return this.o48(plugin instanceof Auth ? plugin : THROW_CCE(), scope);
  };
  Plugin.$metadata$ = objectMeta('Plugin', [HttpClientPlugin]);
  var Plugin_instance;
  function Plugin_getInstance_0() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function Auth(providers) {
    Plugin_getInstance_0();
    this.m47_1 = providers;
  }
  Auth.prototype.p48 = function () {
    return this.m47_1;
  };
  Auth.$metadata$ = classMeta('Auth');
  function AuthProvider() {
  }
  AuthProvider.$metadata$ = interfaceMeta('AuthProvider');
  function $loadTokenCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z48_1 = _this__u8e3s4;
  }
  $loadTokenCOROUTINE$0.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 4;
            $l$loop: while (true) {
              this.a49_1 = this.z48_1.d49_1.xm_1;
              var tmp0_elvis_lhs = this.a49_1;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                tmp_0 = CompletableDeferred$default(null, 1, null);
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var newValue = tmp_0;
              if (this.z48_1.d49_1.atomicfu$compareAndSet(this.a49_1, newValue))
                break $l$loop;
            }

            if (!(this.a49_1 == null)) {
              this.kj_1 = 3;
              suspendResult = this.a49_1.qs(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.kj_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            this.kj_1 = 2;
            suspendResult = this.z48_1.b49_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var newTokens = suspendResult;
            ensureNotNull(this.z48_1.d49_1.xm_1).vu(newTokens);
            ;
            return newTokens;
          case 3:
            return suspendResult;
          case 4:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 4) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $loadTokenCOROUTINE$0.$metadata$ = classMeta('$loadTokenCOROUTINE$0', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function $setTokenCOROUTINE$1(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m49_1 = _this__u8e3s4;
    this.n49_1 = block;
  }
  $setTokenCOROUTINE$1.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 4;
            $l$loop: while (true) {
              this.o49_1 = this.m49_1.c49_1.xm_1;
              var tmp0_elvis_lhs = this.o49_1;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                tmp_0 = CompletableDeferred$default(null, 1, null);
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var newValue = tmp_0;
              if (this.m49_1.c49_1.atomicfu$compareAndSet(this.o49_1, newValue))
                break $l$loop;
            }

            if (this.o49_1 == null) {
              this.kj_1 = 2;
              suspendResult = this.n49_1(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.kj_1 = 1;
              suspendResult = this.o49_1.qs(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            this.p49_1 = suspendResult;
            this.kj_1 = 3;
            continue $sm;
          case 2:
            var newTokens = suspendResult;
            ensureNotNull(this.m49_1.c49_1.xm_1).vu(newTokens);
            ;
            this.m49_1.c49_1.xm_1 = null;
            this.p49_1 = newTokens;
            this.kj_1 = 3;
            continue $sm;
          case 3:
            var newToken = this.p49_1;
            this.m49_1.d49_1.xm_1 = CompletableDeferred(newToken);
            return newToken;
          case 4:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 4) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $setTokenCOROUTINE$1.$metadata$ = classMeta('$setTokenCOROUTINE$1', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function AuthTokenHolder(loadTokens) {
    this.b49_1 = loadTokens;
    this.c49_1 = atomic$ref$1(null);
    this.d49_1 = atomic$ref$1(null);
  }
  AuthTokenHolder.prototype.q49 = function ($cont) {
    var tmp = new $loadTokenCOROUTINE$0(this, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  AuthTokenHolder.prototype.r49 = function (block, $cont) {
    var tmp = new $setTokenCOROUTINE$1(this, block, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  AuthTokenHolder.$metadata$ = classMeta('AuthTokenHolder');
  function bearer(_this__u8e3s4, block) {
    var tmp$ret$2;
    // Inline function 'kotlin.with' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new BearerAuthConfig();
    // Inline function 'kotlin.contracts.contract' call
    block(tmp0_apply);
    tmp$ret$0 = tmp0_apply;
    var tmp1_with = tmp$ret$0;
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$1;
    // Inline function 'io.ktor.client.plugins.auth.providers.bearer.<anonymous>' call
    tmp$ret$1 = _this__u8e3s4.m47_1.b(new BearerAuthProvider(tmp1_with.s49_1, tmp1_with.t49_1, tmp1_with.u49_1, tmp1_with.v49_1));
    tmp$ret$2 = tmp$ret$1;
  }
  function BearerAuthConfig$_refreshTokens$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  BearerAuthConfig$_refreshTokens$slambda.prototype.f4a = function ($this$null, $cont) {
    var tmp = this.g4a($this$null, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  BearerAuthConfig$_refreshTokens$slambda.prototype.uj = function (p1, $cont) {
    return this.f4a(p1 instanceof RefreshTokensParams ? p1 : THROW_CCE(), $cont);
  };
  BearerAuthConfig$_refreshTokens$slambda.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        if (tmp === 0) {
          this.lj_1 = 1;
          return null;
        } else if (tmp === 1) {
          throw this.nj_1;
        }
      } catch ($p) {
        throw $p;
      }
     while (true);
  };
  BearerAuthConfig$_refreshTokens$slambda.prototype.g4a = function ($this$null, completion) {
    var i = new BearerAuthConfig$_refreshTokens$slambda(completion);
    i.e4a_1 = $this$null;
    return i;
  };
  BearerAuthConfig$_refreshTokens$slambda.$metadata$ = classMeta('BearerAuthConfig$_refreshTokens$slambda', undefined, undefined, undefined, [1], CoroutineImpl.prototype);
  function BearerAuthConfig$_refreshTokens$slambda_0(resultContinuation) {
    var i = new BearerAuthConfig$_refreshTokens$slambda(resultContinuation);
    var l = function ($this$null, $cont) {
      return i.f4a($this$null, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function BearerAuthConfig$_loadTokens$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  BearerAuthConfig$_loadTokens$slambda.prototype.p4a = function ($cont) {
    var tmp = this.q4a($cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  BearerAuthConfig$_loadTokens$slambda.prototype.sk = function ($cont) {
    return this.p4a($cont);
  };
  BearerAuthConfig$_loadTokens$slambda.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        if (tmp === 0) {
          this.lj_1 = 1;
          return null;
        } else if (tmp === 1) {
          throw this.nj_1;
        }
      } catch ($p) {
        throw $p;
      }
     while (true);
  };
  BearerAuthConfig$_loadTokens$slambda.prototype.q4a = function (completion) {
    var i = new BearerAuthConfig$_loadTokens$slambda(completion);
    return i;
  };
  BearerAuthConfig$_loadTokens$slambda.$metadata$ = classMeta('BearerAuthConfig$_loadTokens$slambda', undefined, undefined, undefined, [0], CoroutineImpl.prototype);
  function BearerAuthConfig$_loadTokens$slambda_0(resultContinuation) {
    var i = new BearerAuthConfig$_loadTokens$slambda(resultContinuation);
    var l = function ($cont) {
      return i.p4a($cont);
    };
    l.$arity = 0;
    return l;
  }
  function BearerAuthConfig$_sendWithoutRequest$lambda(it) {
    return true;
  }
  function BearerAuthConfig() {
    var tmp = this;
    tmp.s49_1 = BearerAuthConfig$_refreshTokens$slambda_0(null);
    var tmp_0 = this;
    tmp_0.t49_1 = BearerAuthConfig$_loadTokens$slambda_0(null);
    var tmp_1 = this;
    tmp_1.u49_1 = BearerAuthConfig$_sendWithoutRequest$lambda;
    this.v49_1 = null;
  }
  BearerAuthConfig.prototype.r4a = function () {
    return this.s49_1;
  };
  BearerAuthConfig.prototype.s4a = function () {
    return this.t49_1;
  };
  BearerAuthConfig.prototype.t4a = function () {
    return this.u49_1;
  };
  BearerAuthConfig.prototype.u4a = function () {
    return this.v49_1;
  };
  BearerAuthConfig.prototype.v4a = function (block) {
    this.s49_1 = block;
  };
  BearerAuthConfig.prototype.w4a = function (block) {
    this.t49_1 = block;
  };
  BearerAuthConfig.$metadata$ = classMeta('BearerAuthConfig');
  function BearerTokens(accessToken, refreshToken) {
    this.x4a_1 = accessToken;
    this.y4a_1 = refreshToken;
  }
  BearerTokens.$metadata$ = classMeta('BearerTokens');
  function RefreshTokensParams(client, response, oldTokens) {
    this.z4a_1 = client;
    this.a4b_1 = response;
    this.b4b_1 = oldTokens;
  }
  RefreshTokensParams.prototype.c4b = function (_this__u8e3s4) {
    _this__u8e3s4.c39_1.b1q(Plugin_getInstance_0().i48_1, Unit_getInstance());
  };
  RefreshTokensParams.$metadata$ = classMeta('RefreshTokensParams');
  function BearerAuthProvider$addRequestHeaders$lambda($token) {
    return function ($this$headers) {
      var tokenValue = 'Bearer ' + $token.x4a_1;
      var tmp;
      if ($this$headers.a1u(HttpHeaders_getInstance().h20_1)) {
        $this$headers.g1u(HttpHeaders_getInstance().h20_1);
        tmp = Unit_getInstance();
      }
      $this$headers.d1u(HttpHeaders_getInstance().h20_1, tokenValue);
      return Unit_getInstance();
    };
  }
  function BearerAuthProvider$refreshToken$slambda(this$0, $response, resultContinuation) {
    this.l4b_1 = this$0;
    this.m4b_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  BearerAuthProvider$refreshToken$slambda.prototype.r4b = function ($cont) {
    var tmp = this.q4a($cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  BearerAuthProvider$refreshToken$slambda.prototype.sk = function ($cont) {
    return this.r4b($cont);
  };
  BearerAuthProvider$refreshToken$slambda.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 3;
            this.n4b_1 = this.l4b_1.s4b_1;
            this.o4b_1 = this.m4b_1.e3c().t37_1;
            this.kj_1 = 1;
            suspendResult = this.l4b_1.v4b_1.q49(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.p4b_1 = suspendResult;
            this.q4b_1 = new RefreshTokensParams(this.o4b_1, this.m4b_1, this.p4b_1);
            this.kj_1 = 2;
            suspendResult = this.n4b_1(this.q4b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 3) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  BearerAuthProvider$refreshToken$slambda.prototype.q4a = function (completion) {
    var i = new BearerAuthProvider$refreshToken$slambda(this.l4b_1, this.m4b_1, completion);
    return i;
  };
  BearerAuthProvider$refreshToken$slambda.$metadata$ = classMeta('BearerAuthProvider$refreshToken$slambda', undefined, undefined, undefined, [0], CoroutineImpl.prototype);
  function BearerAuthProvider$refreshToken$slambda_0(this$0, $response, resultContinuation) {
    var i = new BearerAuthProvider$refreshToken$slambda(this$0, $response, resultContinuation);
    var l = function ($cont) {
      return i.r4b($cont);
    };
    l.$arity = 0;
    return l;
  }
  function $addRequestHeadersCOROUTINE$2(_this__u8e3s4, request, authHeader, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e4c_1 = _this__u8e3s4;
    this.f4c_1 = request;
    this.g4c_1 = authHeader;
  }
  $addRequestHeadersCOROUTINE$2.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 2;
            this.kj_1 = 1;
            suspendResult = this.e4c_1.v4b_1.q49(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_getInstance();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var token = tmp_0;
            headers(this.f4c_1, BearerAuthProvider$addRequestHeaders$lambda(token));
            ;
            return Unit_getInstance();
          case 2:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 2) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $addRequestHeadersCOROUTINE$2.$metadata$ = classMeta('$addRequestHeadersCOROUTINE$2', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function $refreshTokenCOROUTINE$3(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p4c_1 = _this__u8e3s4;
    this.q4c_1 = response;
  }
  $refreshTokenCOROUTINE$3.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 2;
            this.kj_1 = 1;
            suspendResult = this.p4c_1.v4b_1.r49(BearerAuthProvider$refreshToken$slambda_0(this.p4c_1, this.q4c_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newToken = suspendResult;
            return !(newToken == null);
          case 2:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 2) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $refreshTokenCOROUTINE$3.$metadata$ = classMeta('$refreshTokenCOROUTINE$3', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function BearerAuthProvider(refreshTokens, loadTokens, sendWithoutRequestCallback, realm) {
    this.s4b_1 = refreshTokens;
    this.t4b_1 = sendWithoutRequestCallback;
    this.u4b_1 = realm;
    this.v4b_1 = new AuthTokenHolder(loadTokens);
  }
  BearerAuthProvider.prototype.q48 = function () {
    throw IllegalStateException_init_$Create$('Deprecated');
  };
  BearerAuthProvider.prototype.n47 = function (request) {
    return this.t4b_1(request);
  };
  BearerAuthProvider.prototype.k48 = function (auth) {
    AuthScheme_getInstance();
    if (!(auth.x29_1 === 'Bearer'))
      return false;
    if (this.u4b_1 == null)
      return true;
    if (!(auth instanceof Parameterized))
      return false;
    return auth.r1z('realm') == this.u4b_1;
  };
  BearerAuthProvider.prototype.m48 = function (request, authHeader, $cont) {
    var tmp = new $addRequestHeadersCOROUTINE$2(this, request, authHeader, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  BearerAuthProvider.prototype.l48 = function (response, $cont) {
    var tmp = new $refreshTokenCOROUTINE$3(this, response, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  BearerAuthProvider.$metadata$ = classMeta('BearerAuthProvider', [AuthProvider]);
  //region block: post-declaration
  BearerAuthProvider.prototype.o47 = addRequestHeaders$default;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Plugin_getInstance_0;
  _.$_$.b = BearerTokens;
  _.$_$.c = RefreshTokensParams;
  _.$_$.d = bearer;
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./ktor-ktor-utils-js-ir.js'), require('./ktor-ktor-client-core-js-ir.js'), require('./ktor-ktor-http-js-ir.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'), require('./88b0986a7186d029-atomicfu-js-ir.js')));

